export const NFT_CONTRACT_ID = "archway18g0zxk0pm5j86ls2c7xsysppljxyf75stu4528j3f0dtvx3kvj7qcwvav7";

export const MARKET_CONTRACT_ID = "archway19l8y7x2pl0h42yyau7jl6tz06ane2f99kxh8juc6yw8j907dvjhqy5s4u4"

export const WHITELISTED_CONTRACTS = [
    NFT_CONTRACT_ID
]